import exifRemover from 'exifremove';

/**
 * Get Image Dimension from loaded image, from FileReader
 * @param file
 */
const getImageDimensions = (file) => new Promise((resolved) => {
  const i = new Image();
  i.src = file;
  i.onload = () => {
    resolved({ width: i.width, height: i.height });
  };
});

/**
 * Delete Image Exif
 * @description
 * delete exif data from jpg or jpeg image
 * and return clean image
 * @param {string | ArrayBuffer} image
 * @param {any} imageType
 * @returns
 */
const deleteImageExif = (image: string | ArrayBuffer, imageType: any) => {
  // @ts-ignore
  const buffer = Buffer.from(image);
  const tempBuffer = exifRemover.remove(buffer);
  const blob = new Blob([tempBuffer], { type: imageType });
  const resultImageDeletedExif = new File(
    [blob],
    `temp.${imageType.split('/')[1]}`,
    { type: imageType },
  );
  return resultImageDeletedExif;
};

export {
  getImageDimensions,
  deleteImageExif,
};
